import treatments from '../../api/treatments'
import {getTranslationString, formatDate} from "../../helper";

const success = {
    CREATE_TREATMENT_SUCCESS: {
        title: "SUCCESS",
        content: "Traitement créé avec succès"
    },
    CREATE_REVISION_SUCCESS: {
        title: "SUCCESS",
        content: "Révision créée avec succès"
    },
    CREATE_RADIOGRAPH_SUCCESS: {
        title: "SUCCESS",
        content: "Radiographie créée avec succès"
    },
    UPDATE_TREATMENT_SUCCESS: {
        title: "SUCCESS",
        content: "Traitement mis à jour"
    },
    CLOSE_TREATMENT_SUCCESS: {
        title: "SUCCESS",
        content: "Traitement fermé avec succès"
    },
    RESUME_TREATMENT_SUCCESS: {
        title: "SUCCESS",
        content: "Traitement redémarré avec succès"
    },
}
const errors = {
    CREATE_TREATMENT_ERROR: 'Erreur lors de la création du traitement, merci de réessayer',
    CREATE_REVISION_ERROR: 'Erreur lors de la création de la révision, merci de réessayer',
    CREATE_RADIOGRAPH_ERROR: 'Erreur lors de la création de la radiographie, merci de réessayer',
    UPDATE_TREATMENT_ERROR: 'Erreur lors de la mise à jour du traitement, merci de réessayer',
    CLOSE_TREATMENT_ERROR: 'Erreur lors de la fermeture du traitement, merci de réessayer',
    RESUME_TREATMENT_ERROR: 'Erreur lors du redémarrage du traitement, merci de réessayer',
    GET_TREATMENT_LOADING_ERROR: 'Erreur lors du chargement du traitement, merci de réessayer',
}

// initial state
const state = {
    form: {
        id: null,
        type: null,
        sub_type: null,
        surgery_side: null,
        related_treatment_id: null,
        description: null,
        resurfacing: null,
        alignment: null,
        already_operated: null,
        intervention_date: null,
        studies: []
    },
    revisionForm: {
        id: null,
        active: null,
        type: null,
        revision_at: null,
        gestures: [],
        causes: []
    },
    tagtForm: {
        tagt_preop: null,
        tagt_postop: null
    },
    radiographForm: {
        id: null,
        step: null,
        radiograph_at: null,
        face_cfti: null,
        face_cfte: null,
        schuss_cfti: null,
        schuss_cfte: null,
        profile_slope: null,
        profile_patella_h: null,
        axial_cfp: null,
        axial_hka: null,
        axial_ldfa: null,
        axial_mpta: null,
    },

    gestures: [],
    causes: [],
    selectedTreatment: {
        id: null,
        type: null,
        sub_type: null,
        surgery_side: null,
        related_treatment_id: null,
        description: null,
        resurfacing: null,
        alignment: null,
        already_operated: null,
        intervention_date: null,
        grouped_follow_ups: {
        },
        follow_ups: [{
            follow_up_definition: {
                score_definitions: {

                },
                follow_up_score_definitions: [],
                follow_up_notifications: []
            },
            follow_up_scores: {
                score: null
            },
            follow_up_scores_doctor: {

            },
            follow_up_scores_patient: {

            },
            completed_doctor: false,
            completed_patient: false,
            show_doctor_label: false,
            skip: false
        }],
        medical_case: {
            diagnostic: {
                type: null
            }
        },
        revisions: [
            {
                gestures: [],
                causes: [],
            }

        ],
        radiographs: [],
        studies: [],
        follows_up_arrows_direction_and_colors:{
            definitionNames: [],
            arrows: []
        },
        related_treatments : [{
            id: null,
            type: null,
            sub_type: null,
            surgery_side: null,
            description: null,
            resurfacing: null,
            alignment: null,
            already_operated: null,
            intervention_date: null,
        }],
    },
    showForm: false,
    showTagtForm: false,
    showRevisionForm: false
}

// getters
const getters = {
    getRelatedTreatments: (state, getters) => {
        return [
            {text: getTranslationString('NONE'), value: null},
            ...(state.selectedTreatment?.related_treatments.map((item) => {
            return {text: getters.getTreatmentName(item.id), value: item.id }
        }))]
    },

    getTreatmentName: (state) => (id) => {
        const treatment = state.selectedTreatment?.related_treatments.find(r => r.id === id);
        return treatment ? (
            treatment.id + ' - ' +  treatment.medical_case.name  + ' : ' + getTranslationString(treatment.type) + ', ' + getTranslationString(treatment.sub_type) + ' ' + formatDate(treatment.intervention_date)) : '';
    },
    getTreatmentTypeOptions: () => {
        return [
            {text: getTranslationString('TREATMENT_FULL_KNEE_REPLACEMENT'), value: 'TREATMENT_FULL_KNEE_REPLACEMENT'},
            {text: getTranslationString('TREATMENT_PARTIAL_KNEE_REPLACEMENT'), value: 'TREATMENT_PARTIAL_KNEE_REPLACEMENT'},
            {text: getTranslationString('TREATMENT_REVISION_KNEE_ARTHROPLASTY'), value: 'TREATMENT_REVISION_KNEE_ARTHROPLASTY'},
            //{text: getTranslationString('TREATMENT_FULL_HIP_REPLACEMENT'), value: 'TREATMENT_FULL_HIP_REPLACEMENT'},
            {text: getTranslationString('TREATMENT_INF_CORTISONE'), value: 'TREATMENT_INF_CORTISONE'},
            {text: getTranslationString('TREATMENT_INF_ACIDE_HYALURONIQUE'), value: 'TREATMENT_INF_ACIDE_HYALURONIQUE'},
            {text: getTranslationString('TREATMENT_SURGERY'), value: 'TREATMENT_SURGERY'},
            {text: getTranslationString('TREATMENT_PHYSIO'), value: 'TREATMENT_PHYSIO'},
            {text: getTranslationString('TREATMENT_OSTEO'), value: 'TREATMENT_OSTEO'},
            {text: getTranslationString('TREATMENT_OTHER'), value: 'TREATMENT_OTHER'},
        ]
    },

    getTreatmentSubTypeOptions: () => {
        return {
            TREATMENT_FULL_KNEE_REPLACEMENT:
                [
                    {text: getTranslationString('PTG_STANDARD'), value: 'PTG_STANDARD'},
                    {text: getTranslationString('PTG_MAKO'), value: 'PTG_MAKO'},
                    {text: getTranslationString('PTG_MYKNEE'), value: 'PTG_MYKNEE'},
                    {text: getTranslationString('PTG_NEXT_AR'), value: 'PTG_NEXT_AR'},
                    {text: getTranslationString('PTG_SYMBIOS'), value: 'PTG_SYMBIOS'},
                    {text: getTranslationString('PTG_UPDATE'), value: 'PTG_UPDATE'},
                ],
            TREATMENT_PARTIAL_KNEE_REPLACEMENT:
                [
                    {text: getTranslationString('PUC_STANDARD'), value: 'PUC_STANDARD'},
                    {text: getTranslationString('PUC_MAKO'), value: 'PUC_MAKO'},
                    {text: getTranslationString('PUC_MYKNEE'), value: 'PUC_MYKNEE'},
                    {text: getTranslationString('PUC_NEXT_AR'), value: 'PUC_NEXT_AR'},
                    {text: getTranslationString('PUC_SYMBIOS'), value: 'PUC_SYMBIOS'},
                    {text: getTranslationString('PUC_UPDATE'), value: 'PUC_UPDATE'},
                ],
            TREATMENT_REVISION_KNEE_ARTHROPLASTY:
                [
                    {text: getTranslationString('PTG_STANDARD'), value: 'PTG_STANDARD'},
                    {text: getTranslationString('PTG_MAKO'), value: 'PTG_MAKO'},
                    {text: getTranslationString('PTG_MYKNEE'), value: 'PTG_MYKNEE'},
                    {text: getTranslationString('PTG_NEXT_AR'), value: 'PTG_NEXT_AR'},
                    {text: getTranslationString('PTG_SYMBIOS'), value: 'PTG_SYMBIOS'},
                    {text: getTranslationString('PTG_UPDATE'), value: 'PTG_UPDATE'},
                    {text: getTranslationString('PUC'), value: 'PUC'},
                    {text: getTranslationString('PUC_MAKO'), value: 'PUC_MAKO'},
                    {text: getTranslationString('PUC_MYKNEE'), value: 'PUC_MYKNEE'},
                    {text: getTranslationString('PUC_UPDATE'), value: 'PUC_UPDATE'},
                ]
        }
    },

    getTreatmentSurgerySideOptions: () => {
        return {
            TREATMENT_FULL_KNEE_REPLACEMENT:
                [
                    {text: getTranslationString('LEFT'), value: 'LEFT'},
                    {text: getTranslationString('RIGHT'), value: 'RIGHT'},
                    {text: getTranslationString('BOTH'), value: 'BOTH'}
                ],
                    TREATMENT_PARTIAL_KNEE_REPLACEMENT:
            [
                {text: getTranslationString('LEFT'), value: 'LEFT'},
                {text: getTranslationString('RIGHT'), value: 'RIGHT'},
                {text: getTranslationString('BOTH'), value: 'BOTH'}
            ],
                TREATMENT_SURGERY:
            [
                {text: getTranslationString('LEFT'), value: 'LEFT'},
                {text: getTranslationString('RIGHT'), value: 'RIGHT'},
                {text: getTranslationString('BOTH'), value: 'BOTH'}
            ]
        }
    }

}

// actions
const actions = {

    createTreatment({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            treatments.add(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.CREATE_TREATMENT_SUCCESS.title, content: success.CREATE_TREATMENT_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_TREATMENT_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    createRevision({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            treatments.addRevision(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, state.revisionForm, rootState.axios).then(result => {
                commit('addRevision', result.data)
                commit('notifications/showSuccess', {
                    title: success.CREATE_REVISION_SUCCESS.title, content: success.CREATE_REVISION_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_REVISION_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    createRadiograph({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            treatments.addRadiograph(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, state.radiographForm, rootState.axios).then(result => {
                commit('addRadiograph', result.data)
                commit('notifications/showSuccess', {
                    title: success.CREATE_RADIOGRAPH_SUCCESS.title, content: success.CREATE_RADIOGRAPH_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CREATE_RADIOGRAPH_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    updateTreatment({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            treatments.update(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, state.form, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.UPDATE_TREATMENT_SUCCESS.title, content: success.UPDATE_TREATMENT_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_TREATMENT_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    updateTagt({state, commit, rootState}) {
        return new Promise((resolve, reject) => {
            treatments.updateTagt(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, state.tagtForm, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.UPDATE_TREATMENT_SUCCESS.title, content: success.UPDATE_TREATMENT_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.UPDATE_TREATMENT_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    getTreatmentInfo({ commit, rootState}) {
        return new Promise((resolve, reject) => {
            treatments.get(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.axios).then(result => {
                commit('setSelectedTreatment', result.data.treatment)
                commit('setCauses', result.data.causes)
                commit('setGestures', result.data.gestures)
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.GET_TREATMENT_LOADING_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    closeTreatment({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            treatments.close(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, payload, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.CLOSE_TREATMENT_SUCCESS.title,
                    content: success.CLOSE_TREATMENT_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.CLOSE_TREATMENT_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    },
    resumeTreatment({state, commit, rootState}, payload) {
        return new Promise((resolve, reject) => {
            treatments.resume(rootState.patients.selectedPatient.id, rootState.medical_cases.selectedMedicalCase.id, rootState.treatments.selectedTreatment.id, rootState.axios).then(result => {
                commit('notifications/showSuccess', {
                    title: success.RESUME_TREATMENT_SUCCESS.title,
                    content: success.RESUME_TREATMENT_SUCCESS.content
                }, {root: true})
                resolve(result)
            }).catch(reason => {
                commit('notifications/showError', {
                    title: errors.RESUME_TREATMENT_ERROR, content: reason
                }, {root: true})
                reject(reason)
            })
        })
    }
}

// mutations
const mutations = {
    setFormId(state, value) {
        state.form.id = value
    },
    setFormType(state, value) {
        state.form.type = value
    },
    setFormSubType(state, value) {
        state.form.sub_type = value
    },
    setFormParticipantStudy(state, value) {
        state.form.studies = value
    },
    setFormSurgerySide(state, value) {
        state.form.surgery_side = value
    },
    setFormRelatedTreatmentId(state, value) {
        state.form.related_treatment_id = value
    },
    setFormInterventionDate(state, value) {
        state.form.intervention_date = value
    },
    setFormDescription(state, value) {
        state.form.description = value
    },
    setFormResurfacing(state, value) {
        state.form.resurfacing = value
    },
    setFormAlignment(state, value) {
        state.form.alignment = value
    },
    setFormAlreadyOperated(state, value) {
        state.form.already_operated = value
    },
    initForm (state, value) {
        if (value != null) {
            state.form.id = value.id
            state.form.type = value.type
            state.form.sub_type = value.sub_type
            state.form.surgery_side = value.surgery_side
            state.form.related_treatment_id = value.related_treatment_id
            state.form.description = value.description
            state.form.resurfacing = value.resurfacing
            state.form.alignment = value.alignment
            state.form.already_operated = value.already_operated
            state.form.intervention_date = value.intervention_date
            state.form.studies = value.studies
        } else {
            state.form.id = null
            state.form.type = null
            state.form.sub_type = null
            state.form.surgery_side = null
            state.form.related_treatment_id = null
            state.form.description = null
            state.form.resurfacing = null
            state.form.alignment = null
            state.form.already_operated = null
            state.form.intervention_date = null
            state.form.studies = []
        }
    },
    initRevisionForm (state) {
        state.revisionForm.id = null
        state.revisionForm.active = false
        state.revisionForm.type = null
        state.revisionForm.revision_at = null
        state.revisionForm.gestures = []
        state.revisionForm.causes = []
    },
    initTagtForm (state, value) {
        state.tagtForm.tagt_preop = value.tagt_preop
        state.tagtForm.tagt_postop = value.tagt_postop
    },
    initRadiographForm (state) {
        state.radiographForm.id = null
        state.radiographForm.step = null
        state.radiographForm.radiograph_at = null
        state.radiographForm.face_cfti = null
        state.radiographForm.face_cfte = null
        state.radiographForm.schuss_cfti = null
        state.radiographForm.schuss_cfte = null
        state.radiographForm.profile_slope = null
        state.radiographForm.profile_patella_h = null
        state.radiographForm.axial_cfp = null
        state.radiographForm.axial_hka = null
        state.radiographForm.axial_ldfa = null
        state.radiographForm.axial_mpta = null
    },
    setShowForm(state, value) {
        state.showForm = value
    },
    setShowTagtForm(state, value) {
        state.showTagtForm = value
    },
    setShowRevisionForm(state, value) {
        state.showRevisionForm = value
    },
    setRevisionFormActive(state, value) {
        state.revisionForm.active = value
    },
    setRevisionFormType(state, value) {
        state.revisionForm.type = value
    },
    setRevisionFormDate(state, value) {
        state.revisionForm.revision_at = value
    },
    setRevisionGestures(state, values) {
        state.revisionForm.gestures = values
    },
    setRevisionCauses(state, values) {
        state.revisionForm.causes = values
    },
    setRadiographFormStep(state, value) {
        state.radiographForm.step = value
    },
    setRadiographFormDate(state, value) {
        state.radiographForm.radiograph_at = value
    },
    setRadiographFormFaceCfti(state, value) {
        state.radiographForm.face_cfti = value
    },
    setRadiographFormFaceCfte(state, value) {
        state.radiographForm.face_cfte = value
    },
    setRadiographFormSchussCfti(state, value) {
        state.radiographForm.schuss_cfti = value
    },
    setRadiographFormSchussCfte(state, value) {
        state.radiographForm.schuss_cfte = value
    },
    setRadiographFormProfileSlope(state, value) {
        state.radiographForm.profile_slope = value
    },
    setRadiographFormProfilePatellaH(state, value) {
        state.radiographForm.profile_patella_h = value
    },
    setRadiographFormAxialCfp(state, value) {
        state.radiographForm.axial_cfp = value
    },
    setRadiographFormAxialHka(state, value) {
        state.radiographForm.axial_hka = value
    },
    setRadiographFormAxialLdfa(state, value) {
        state.radiographForm.axial_ldfa = value
    },
    setRadiographFormAxialMpta(state, value) {
        state.radiographForm.axial_mpta = value
    },
    setSelectedTreatmentId (state, value) {
        state.selectedTreatment.id = value
    },
    setTagtFormPreop (state, value) {
        state.tagtForm.tagt_preop = value
    },
    setTagtFormPostop (state, value) {
        state.tagtForm.tagt_postop = value
    },

    setSelectedTreatment (state, value) {
        state.selectedTreatment = value
        if (value.treatment) {
            state.form = { ...value.treatment}
        } else {
            state.form = {
                id: null,
                type: null,
                sub_type: null,
                surgery_side: null,
                related_treatment_id: null,
                description: null,
                resurfacing: null,
                alignment: null,
                already_operated: null,
                intervention_date: null,
                studies: []
            }
        }
    },
    setCauses(state, value) {
        state.causes = value
    },
    setGestures(state, value) {
        state.gestures = value
    },
    addRevision (state, value) {
        state.selectedTreatment.revisions = [value, ...state.selectedTreatment.revisions]
    },
    addRadiograph (state, value) {
        state.selectedTreatment.radiographs = [value, ...state.selectedTreatment.radiographs]
    },
    resetForm (state) {
        state.form.id = null
        state.form.type = null
        state.form.sub_type = null
        state.form.surgery_side = null
        state.form.related_treatment_id = null
        state.form.description = null
        state.form.resurfacing = null
        state.form.alignment = null
        state.form.already_operated = null
        state.form.intervention_date = null
        state.form.studies = []
    },
    setDefaultStudy (state, study) {
        state.form.studies = [study]
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
